package pl.zar.tikthrow.util

import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings

actual fun createPostsSettings(): Settings = StorageSettings()
